import React, { useState } from "react";
import { Box } from "@mui/material";

interface IProps {
  children?: React.ReactNode;
  handleTransformX: (number: number) => void;
  handleTransformY: (number: number) => void;
}

export const DragContainer = (props: IProps) => {
  const { children, handleTransformX, handleTransformY } = props;

  type Direction = "up" | "down" | "left" | "right";
  const [dragging, setDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number | null>(null);
  const [startY, setStartY] = useState<number | null>(null);
  const [direction, setDirection] = useState<Direction | null>(null);

  const body = document.querySelector("body");
  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>): void => {
    if (body) {
      body.style.overflow = "hidden";
    }
    setStartX(e.touches[0].clientX);
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>): void => {
    e.preventDefault();

    if (!startX || !startY) return;

    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;

    const deltaX = currentX - startX;
    const deltaY = currentY - startY;

    const newDirection =
      Math.abs(deltaX) > Math.abs(deltaY)
        ? deltaX > 0
          ? "right"
          : "left"
        : deltaY > 0
          ? "down"
          : "up";

    if (!dragging && Math.abs(deltaX) + Math.abs(deltaY) > 10) {
      setDragging(true);
    }

    if (newDirection !== direction) {
      setDirection(newDirection);
    }
  };

  const handleTouchEnd = (): void => {
    if (dragging) {
      if (body) body.style.overflow = "initial";
      setDragging(false);
      if (direction === "left") {
        handleTransformX(1);
      } else if (direction === "right") {
        handleTransformX(-1);
      } else if (direction === "up") {
        handleTransformY(1);
      } else if (direction === "down") {
        handleTransformY(-1);
      }
      setDirection(null);
      setStartX(null);
      setStartY(null);
    }
  };

  return (
    <Box
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {children}
    </Box>
  );
};
